import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import i18n from "@Shared/@i18n";
import { formatNumeral } from "@Shared/@Utils/helpers/helpers";
import { computed, reactive } from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";
import { useAddress } from "@Shared/@Composables/generic/useAddress";
import { isEmpty, uniqBy } from "lodash";
import * as ApplicationStandAloneActions from "@Client/@Modules/application-standalone/store/application-standalone-actions";
import { useApplicationStandaloneStoreActions } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { FILL_OUT_SECTIONS } from "@Client/@Utils/enums";
export const useApplicantHelpers = () => {
  const {
    bindApplication,
    addNestedField,
    removeNestedField,
    decryptApplicantSin
  } = useBindApplication();
  const {
    UPDATE_APPLICATION_FIELD
  } = useApplicationStandaloneStoreActions([ApplicationStandAloneActions.UPDATE_APPLICATION_FIELD]);
  const {
    CONSOLIDATED_REQUEST_FILL_OUT,
    GUEST_FILL_OUT_CLIENT_DETAILS,
    HAS_CONSOLIDATED_REQUEST,
    CONSOLIDATED_REQUEST_CLIENT_USERNAME,
    APPLICANTS_WITHOUT_REQUEST,
    IS_FILL_OUT
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.CONSOLIDATED_REQUEST_FILL_OUT, ApplicationStandaloneGetters.GUEST_FILL_OUT_CLIENT_DETAILS, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST, ApplicationStandaloneGetters.CONSOLIDATED_REQUEST_CLIENT_USERNAME, ApplicationStandaloneGetters.APPLICANTS_WITHOUT_REQUEST, ApplicationStandaloneGetters.IS_FILL_OUT]);
  const mainApplicant = bindApplication(APPLICATION_PATH.MAIN_APPLICANT, {});
  const coApplicants = bindApplication(APPLICATION_PATH.CO_APPLICANTS, []);
  const allApplicants = computed(() => {
    var _coApplicants$value$m, _context, _GUEST_FILL_OUT_CLIEN;
    const coApplicantsModel = (_coApplicants$value$m = coApplicants == null ? void 0 : _mapInstanceProperty(_context = coApplicants.value).call(_context, (coap, index) => _objectSpread({
      index,
      isMainApplicant: false
    }, coap))) != null ? _coApplicants$value$m : [];
    return [_objectSpread(_objectSpread({}, mainApplicant.value), {}, {
      index: -1,
      isMainApplicant: true,
      id: (_GUEST_FILL_OUT_CLIEN = GUEST_FILL_OUT_CLIENT_DETAILS.value.clientUsername) != null ? _GUEST_FILL_OUT_CLIEN : CONSOLIDATED_REQUEST_CLIENT_USERNAME.value
    }), ...coApplicantsModel];
  });
  const getApplicantIdByIndex = index => allApplicants.value[index].id;
  const allEmployments = computed(() => {
    var _context2;
    if (!allApplicants.value.length || isEmpty(allApplicants.value[0])) {
      return [];
    }
    return _reduceInstanceProperty(_context2 = allApplicants.value).call(_context2, (acc, applicant, applicantIndex) => {
      var _applicant$employment;
      if (!(applicant != null && (_applicant$employment = applicant.employment) != null && _applicant$employment.length)) return acc;
      applicant.employment.forEach((employment, incomeIndex) => {
        acc.push(_objectSpread(_objectSpread({}, employment), {}, {
          index: applicant.index,
          applicantIndex,
          incomeIndex,
          applicantId: applicant.id
        }));
      });
      return acc;
    }, []);
  });
  const allAdditionalIncomes = computed(() => {
    var _context3;
    if (!allApplicants.value.length || isEmpty(allApplicants.value[0])) {
      return [];
    }
    return _reduceInstanceProperty(_context3 = allApplicants.value).call(_context3, (acc, applicant, applicantIndex) => {
      var _applicant$otherInco;
      if (!(applicant != null && (_applicant$otherInco = applicant["other-income"]) != null && _applicant$otherInco.length)) return acc;
      applicant["other-income"].forEach((income, incomeIndex) => {
        acc.push(_objectSpread(_objectSpread({}, income), {}, {
          applicantIndex,
          incomeIndex,
          applicantId: applicant.id
        }));
      });
      return acc;
    }, []);
  });
  const allAssets = computed(() => {
    var _context4;
    if (!allApplicants.value.length || isEmpty(allApplicants.value[0])) {
      return [];
    }
    return _reduceInstanceProperty(_context4 = allApplicants.value).call(_context4, (acc, applicant, applicantIndex) => {
      var _applicant$assets;
      if (!(applicant != null && (_applicant$assets = applicant.assets) != null && _applicant$assets.length)) return acc;
      applicant.assets.forEach((asset, assetIndex) => {
        acc.push(_objectSpread(_objectSpread({}, asset), {}, {
          applicantIndex,
          assetIndex,
          applicantId: applicant.id
        }));
      });
      return acc;
    }, []);
  });
  const allIdentifications = computed(() => {
    var _context5;
    if (!allApplicants.value.length || isEmpty(allApplicants.value[0])) {
      return [];
    }
    return _reduceInstanceProperty(_context5 = allApplicants.value).call(_context5, (acc, applicant, applicantIndex) => {
      var _applicant$identifica;
      if (!(applicant != null && (_applicant$identifica = applicant.identifications) != null && _applicant$identifica.length)) return acc;
      applicant.identifications.forEach((identification, identificationIndex) => {
        acc.push(_objectSpread(_objectSpread({}, identification), {}, {
          applicantIndex,
          identificationIndex,
          applicantId: applicant.id
        }));
      });
      return acc;
    }, []);
  });
  const allLiabilities = computed(() => {
    var _context6;
    if (!allApplicants.value.length || isEmpty(allApplicants.value[0])) {
      return [];
    }
    return _reduceInstanceProperty(_context6 = allApplicants.value).call(_context6, (acc, applicant, applicantIndex) => {
      var _applicant$liabilitie;
      if (!(applicant != null && (_applicant$liabilitie = applicant.liabilities) != null && _applicant$liabilitie.length)) return acc;
      applicant.liabilities.forEach((liability, liabilityIndex) => {
        acc.push(_objectSpread(_objectSpread({}, liability), {}, {
          applicantIndex,
          liabilityIndex,
          applicantId: applicant.id
        }));
      });
      return acc;
    }, []);
  });
  const allOtherProperties = computed(() => {
    var _context7;
    if (!allApplicants.value.length || isEmpty(allApplicants.value[0])) {
      return [];
    }
    return _reduceInstanceProperty(_context7 = allApplicants.value).call(_context7, (acc, applicant, applicantIndex) => {
      var _applicant$otherProp;
      if (!(applicant != null && (_applicant$otherProp = applicant["other-properties"]) != null && _applicant$otherProp.length)) return acc;
      applicant["other-properties"].forEach((property, otherPropertyIndex) => {
        acc.push(_objectSpread(_objectSpread({}, property), {}, {
          applicantIndex,
          otherPropertyIndex,
          applicantId: applicant.id
        }));
      });
      return acc;
    }, []);
  });
  const allOtherPropertiesExistingMortgage = computed(() => {
    var _context8;
    if (!allApplicants.value.length || isEmpty(allApplicants.value[0])) {
      return [];
    }
    return _reduceInstanceProperty(_context8 = allApplicants.value).call(_context8, (acc, applicant, applicantIndex) => {
      var _applicant$otherProp2;
      if (!(applicant != null && (_applicant$otherProp2 = applicant["other-properties"]) != null && _applicant$otherProp2.length)) return acc;
      applicant["other-properties"].forEach((property, otherPropertyIndex) => {
        var _property$otherPrope;
        if (!(property != null && (_property$otherPrope = property["other-property-existing-mortgages"]) != null && _property$otherPrope.length)) return acc;
        property["other-property-existing-mortgages"].forEach((existingMortgage, otherPropertyExistingMortgageIndex) => {
          acc.push(_objectSpread(_objectSpread({}, existingMortgage), {}, {
            applicantIndex,
            index: applicant.index,
            otherPropertyIndex,
            otherPropertyExistingMortgageIndex,
            applicantId: applicant.id
          }));
        });
      });
      return acc;
    }, []);
  });
  const addEmptyCoApplicant = () => {
    const id = uuidv4();
    addNestedField(APPLICATION_PATH.CO_APPLICANTS, {
      id
    });
    updateCoappFieldValue();
  };
  const deleteCoApplicant = index => {
    removeNestedField(APPLICATION_PATH.CO_APPLICANTS, index);
    updateCoappFieldValue();
  };
  const addLivingHistoryAddress = applicantIndex => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    const addressesPath = "[personal-details][addresses]";
    addNestedField(currentApplicantPath + addressesPath);
  };
  const deleteLivingHistoryAddress = (applicantIndex, addressIndex) => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    const addressesPath = "[personal-details][addresses]";
    removeNestedField(currentApplicantPath + addressesPath, addressIndex);
  };
  const applicantNameFromIndex = applicantIndex => {
    var _allApplicants$value$, _applicant$personalD, _applicant$personalD2;
    const applicant = (_allApplicants$value$ = allApplicants.value[applicantIndex]) != null ? _allApplicants$value$ : {};
    const firstName = (applicant == null ? void 0 : (_applicant$personalD = applicant["personal-details"]) == null ? void 0 : _applicant$personalD["first-name"]) || "";
    const lastName = (applicant == null ? void 0 : (_applicant$personalD2 = applicant["personal-details"]) == null ? void 0 : _applicant$personalD2["last-name"]) || "";
    if (firstName || lastName) return [firstName, lastName].join(" ");
    return applicantIndex === 0 ? i18n.t("application-form.main-applicant").toString() : `${formatNumeral(applicantIndex, "0o")} ${i18n.t("application-form.co-applicant").toString().toLowerCase()}`;
  };
  const applicantsAsOptions = computed(() => {
    var _context9;
    return _mapInstanceProperty(_context9 = allApplicants.value).call(_context9, (applicant, applicantIndex) => {
      return {
        value: applicantIndex,
        label: applicantNameFromIndex(applicantIndex),
        id: applicant.id
      };
    });
  });
  const addressesAsOptions = computed(() => {
    var _context0;
    return uniqBy(_flatMapInstanceProperty(_context0 = allApplicants.value).call(_context0, (applicant, applicantIndex) => {
      var _applicant$personalD3, _applicant$personalD4, _applicant$personalD5;
      return (_applicant$personalD3 = applicant == null ? void 0 : (_applicant$personalD4 = applicant["personal-details"]) == null ? void 0 : (_applicant$personalD5 = _applicant$personalD4.addresses) == null ? void 0 : _flatMapInstanceProperty(_applicant$personalD5).call(_applicant$personalD5, (address, addressIndex) => {
        const formattedAddress = useAddress(address).fullAddress.value;
        if (formattedAddress) return {
          id: `address-${applicantIndex}-${addressIndex}`,
          label: formattedAddress,
          value: address
        };
        return [];
      })) != null ? _applicant$personalD3 : [];
    }), "label");
  });
  const applicationHasCoApplicants = computed(() => coApplicants.value && !!coApplicants.value.length);
  const handleDecryptSin = async (applicantIndex, loadingRef) => {
    const loading = typeof (loadingRef == null ? void 0 : loadingRef.value) === "undefined" ? reactive({
      value: false
    }) : loadingRef;
    loading.value = true;
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    await decryptApplicantSin(currentApplicantPath + "[personal-details][sin]", applicantIndex);
    loading.value = false;
  };
  const updateCoappFieldValue = () => {
    UPDATE_APPLICATION_FIELD({
      path: "[main-applicant][personal-details][coapp]",
      value: !!coApplicants.value.length
    });
  };
  const applicantsToFillOut = computed(() => {
    var _CONSOLIDATED_REQUEST, _context1;
    const applicants = ((_CONSOLIDATED_REQUEST = _findInstanceProperty(_context1 = CONSOLIDATED_REQUEST_FILL_OUT.value).call(_context1, ({
      key
    }) => key === FILL_OUT_SECTIONS.PERSONAL_INFORMATION)) == null ? void 0 : _CONSOLIDATED_REQUEST.applicants) || [];
    if (IS_FILL_OUT.value) return applicants;
    return [...applicants, ...APPLICANTS_WITHOUT_REQUEST.value];
  });
  const isApplicantVisibleFromFillOut = (applicantId = "") => {
    var _context10;
    if (applicantId && HAS_CONSOLIDATED_REQUEST.value) return _includesInstanceProperty(_context10 = applicantsToFillOut.value).call(_context10, applicantId);
    return true;
  };
  const applicantNameFromId = (applicantId = "") => {
    var _allApplicants$value$2, _context11, _applicant$personalD6, _applicant$personalD7;
    const applicant = (_allApplicants$value$2 = _findInstanceProperty(_context11 = allApplicants.value).call(_context11, ({
      id
    }) => id === applicantId)) != null ? _allApplicants$value$2 : {};
    const givenName = (applicant == null ? void 0 : (_applicant$personalD6 = applicant["personal-details"]) == null ? void 0 : _applicant$personalD6["first-name"]) || "";
    const familyName = (applicant == null ? void 0 : (_applicant$personalD7 = applicant["personal-details"]) == null ? void 0 : _applicant$personalD7["last-name"]) || "";
    return {
      givenName,
      familyName
    };
  };
  return {
    allApplicants,
    allEmployments,
    allAdditionalIncomes,
    mainApplicant,
    coApplicants,
    addEmptyCoApplicant,
    deleteCoApplicant,
    addLivingHistoryAddress,
    deleteLivingHistoryAddress,
    applicantNameFromIndex,
    applicantsAsOptions,
    addressesAsOptions,
    applicationHasCoApplicants,
    allAssets,
    allOtherProperties,
    allOtherPropertiesExistingMortgage,
    allIdentifications,
    allLiabilities,
    handleDecryptSin,
    applicantsToFillOut,
    isApplicantVisibleFromFillOut,
    getApplicantIdByIndex,
    applicantNameFromId
  };
};